module.exports = __webpack_public_path__ + "static/media/1018969.86b88803.png";